import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const features = [
  { t: "One-click demand drafts", d: "Professional, tailored letters in minutes." },
  { t: "DMCA takedown generator", d: "Platform-ready notices for fast removals." },
  { t: "Platform templates", d: "FB, IG, TikTok, X, forums and more." },
  { t: "Evidence checklist", d: "Never miss critical supporting details." },
  { t: "Version history", d: "Track edits and keep an audit trail." },
  { t: "Export & share", d: "PDF/Docx and secure share links." },
];

export default function FeaturesGrid() {
  return (
    <section id="features" className="py-16">
      <div className="max-w-[1200px] mx-auto px-4">
        <h2 className="text-3xl font-semibold">Features</h2>
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => (
            <Card key={f.t} className="bg-card">
              <CardHeader>
                <CardTitle className="text-base">{f.t}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">{f.d}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
